document.querySelector('.bldg-salesforce-form').addEventListener('submit', function (e) {
    let formValid = true;

    // Select all required inputs and textareas
    const requiredFields = this.querySelectorAll('input[required], textarea[required]');

    requiredFields.forEach(field => {
      // Trim whitespace and check for empty string
      if (field.value.trim() === '') {
        formValid = false;
        field.classList.add('field-error');
      } else {
        field.classList.remove('field-error');
      }
    });

    if (!formValid) {
      e.preventDefault(); // Stop form submission
      alert('Please fill out all required fields properly.');
    }
  });